import { useTranslation } from 'hooks';
import cls from './export-settings.module.scss';
import {
  ExportSettingsProps,
  ToggleSectionKey,
} from '../../export-modal.types';
import { Toggle } from 'shared/ui/toggle/toggle';

const CHILD_SECTIONS: { key: ToggleSectionKey; translationKey: string }[] = [
  { key: 'tar', translationKey: 'technicalAccessibility' },
  { key: 'bic', translationKey: 'businessInfoCompleteness' },
  { key: 'off', translationKey: 'offerings' },
];

export const ExportSettings: React.FC<ExportSettingsProps> = ({
  settings,
  onChange,
}) => {
  const { t } = useTranslation();
  const { analysis, improvements } = settings;

  const analysisGroupToggle = analysis.tar || analysis.bic || analysis.off;

  const improvementsGroupToggle =
    improvements.tar || improvements.bic || improvements.off;

  const handleAnalysisToggle = (enabled: boolean) => {
    onChange({
      ...settings,
      analysis: { tar: enabled, bic: enabled, off: enabled },
    });
  };

  const handleImprovementsToggle = (enabled: boolean) => {
    onChange({
      ...settings,
      improvements: { tar: enabled, bic: enabled, off: enabled },
    });
  };

  const handleChildAnalysisToggle = (
    key: ToggleSectionKey,
    enabled: boolean
  ) => {
    onChange({
      ...settings,
      analysis: { ...analysis, [key]: enabled },
    });
  };

  const handleChildImprovementsToggle = (
    key: ToggleSectionKey,
    enabled: boolean
  ) => {
    onChange({
      ...settings,
      improvements: { ...improvements, [key]: enabled },
    });
  };

  return (
    <div>
      <section className={cls.settingsGroup}>
        <Toggle
          label={t('analysisDesc')}
          isEnabled={analysisGroupToggle}
          setIsEnabled={handleAnalysisToggle}
          heading={t('analysis')}
        />
        <div className={cls.childToggles}>
          {CHILD_SECTIONS.map(({ key, translationKey }) => (
            <Toggle
              key={key}
              label={t(translationKey)}
              isEnabled={analysis[key]}
              setIsEnabled={enable => handleChildAnalysisToggle(key, enable)}
            />
          ))}
        </div>
      </section>

      <section className={cls.settingsGroup}>
        <Toggle
          label={t('improvementsDesc')}
          isEnabled={improvementsGroupToggle}
          setIsEnabled={handleImprovementsToggle}
          heading={t('improvements')}
        />
        <div className={cls.childToggles}>
          {CHILD_SECTIONS.map(({ key, translationKey }) => (
            <Toggle
              key={key}
              label={t(translationKey)}
              isEnabled={improvements[key]}
              setIsEnabled={enable =>
                handleChildImprovementsToggle(key, enable)
              }
            />
          ))}
        </div>
      </section>
    </div>
  );
};
